/* RESPONSIBLE TEAM: team-fin-voice */

export type FinVoiceVadType = 'default_vad' | 'semantic_vad';

export type FinVoiceEagernessLevel = 'low' | 'medium' | 'high' | 'auto';

export interface FinVoiceDefaultVadSettings {
  threshold: number;
  prefixPaddingMs: number;
  silenceDurationMs: number;
  createResponse: boolean;
  interruptResponse: boolean;
}

export const DEFAULT_VAD_SETTINGS: FinVoiceDefaultVadSettings = {
  threshold: 0.2,
  prefixPaddingMs: 300,
  silenceDurationMs: 500,
  createResponse: false,
  interruptResponse: true,
};

/**
 * Strips VAD settings that match the defaults, so the server can apply its own.
 * Returns only the overridden values.
 */
export function stripDefaultVadValues(
  settings: FinVoiceDefaultVadSettings,
): Partial<FinVoiceDefaultVadSettings> {
  let result: Partial<FinVoiceDefaultVadSettings> = {};
  for (let key of Object.keys(DEFAULT_VAD_SETTINGS) as (keyof FinVoiceDefaultVadSettings)[]) {
    if (settings[key] !== DEFAULT_VAD_SETTINGS[key]) {
      (result as Record<string, unknown>)[key] = settings[key];
    }
  }
  return result;
}

export interface FinVoiceSemanticVadSettings {
  type: 'semantic_vad';
  eagerness: FinVoiceEagernessLevel;
}

export type FinVoiceVadSettings = FinVoiceDefaultVadSettings | FinVoiceSemanticVadSettings;
